<template>
	<div>
		<div class="bs-example">
			<div class="lineone">
				<div class="select-option">
					<div class="label-name">{{ $t('receivableList.billNumber') }}</div>
					<a-auto-complete
						:placeholder="$t('receivableList.billNumber')"
						v-model.trim="req.params.condition.blNo"
						:data-source="dataSourceblNumber"
						:allowClear="true"
						size="small"
						class="input-style"
						@select="onSelect"
						@change="onChangeinput"
					/>
				</div>
				<div class="select-option">
					<div class="label-name">{{ $t('businessDispatch.businessNumber') }}</div>
					<a-auto-complete
						:placeholder="$t('businessDispatch.businessNumber')"
						v-model.trim="req.params.condition.orderNumber"
						:data-source="dataSourceblOrderNumber"
						:allowClear="true"
						size="small"
						class="input-style"
						@select="onSelect"
						@change="onChangeinput"
					/>
				</div>
				<div class="select-option">
					<div class="label-name">{{ $t('businessDispatch.containerNumber') }}</div>
					<a-auto-complete
						:placeholder="$t('businessDispatch.containerNumber')"
						v-model.trim="req.params.condition.containerNumber"
						:data-source="dataSourceblContainerNumber"
						:allowClear="true"
						size="small"
						class="input-style"
						@select="onSelect"
						@change="onChangeinput"
					/>
				</div>
				<div class="select-date">
					<div class="label-name">{{ $t('businessDispatch.boxTime') }}</div>
					<div class="input-form timepicker" v-if="show">
						<a-range-picker
							:locale="locale"
							:ranges="{
								[$t('today')]: [moment(), moment()],
								[$t('currentMonth')]: [moment(), moment().endOf('month')],
							}"
							@change="onChange"
							v-model="dateRange"
							:valueFormat="dateFormat"
							:format="monthFormat"
							dropdownClassName="dateRangeClass"
							:getCalendarContainer="(triggerNode) => triggerNode.parentNode"
							size="small"
							class="range-picker"
						/>
					</div>
				</div>
			</div>
			<div class="linetwo">
				<div class="select-option">
					<div class="label-name">{{ $t('businessDispatch.portArea') }}</div>
					<a-auto-complete
						:placeholder="$t('businessDispatch.portArea')"
						v-model.trim="req.params.condition.portDistrict"
						:data-source="dataSourceblPortDistrict"
						:allowClear="true"
						size="small"
						class="input-style"
						@change="onChangeinput"
					/>
				</div>
				<div class="select-option">
					<div class="label-name">{{ $t('businessDispatch.yard') }}</div>
					<a-input
						:placeholder="$t('businessDispatch.yard')"
						v-model.trim="req.params.condition.depot"
						:allowClear="true"
						size="small"
						class="input-style"
					/>
				</div>
				<div class="select-option">
					<div class="label-name">{{ $t('businessDispatch.customer') }}</div>
					<a-auto-complete
						:placeholder="$t('businessDispatch.customer')"
						v-model.trim="req.params.condition.customerName"
						:data-source="dataSourceblCustomerName"
						:allowClear="true"
						size="small"
						class="input-style"
						@change="onChangeinput"
					/>
				</div>
				<div class="select-option">
					<div class="label-name">{{ $t('receivableList.importAndExport') }}</div>
					<a-select
						:placeholder="$t('receivableList.importAndExport')"
						v-model.trim="req.params.condition.boundType"
						:getPopupContainer="(triggerNode) => triggerNode.parentNode"
						:allowClear="true"
						size="small"
						class="input-style"
					>
						<a-select-option value="">
							{{ $t('all') }}
						</a-select-option>
						<a-select-option value="IB">
							{{ $t('import') }}
						</a-select-option>
						<a-select-option value="OB">
							{{ $t('export') }}
						</a-select-option>
					</a-select>
				</div>
			</div>
			<div class="linethree">
				<div>
					<a-button
						style="margin-right: 10px;"
						type="primary"
						@click="search"
						size="small"
					>
						{{ $t('search') }}
					</a-button>
					<a-button size="small" @click="reset">{{ $t('reset') }}</a-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
// import dayjs from "dayjs";
// import { customerlist } from "../api/basicData";
import { queryReceivableList } from "../../api/receivable";
import { searchReqParam } from "../../utils/searchReqParam";
export default {
	name: "ReceivableSearchForm",
	data() {
		return {
			searchFormList: searchReqParam(),
			req: {
				params: {
					condition: {
						blNo: "", //	提单号
						boundType: undefined, // 进出口类型
						companyId: "", // 公司ID
						containerNumber: "",
						customerName: "", // 客户名称
						depot: "", // 堆场
						orderNumber: "", //  订单号
						planArrivalTimeStart: '',
							// dayjs()
							// 	.startOf("month")
							// 	.format("YYYY-MM-DD") + " 00:00:00", // 做箱时间(起)
						planArrivalTimeEnd: '',
							// dayjs()
							// 	.endOf("month")
							// 	.format("YYYY-MM-DD") + " 23:59:59", // 做箱时间(止)
						portDistrict: "", // 港区
					},
					page: 1, // 页码
					pageSize: 10, // 页容量
				},
			},
			dateRange: [
				// dayjs()
				// 	.startOf("month")
				// 	.format("YYYY-MM-DD"),
				// dayjs()
				// 	.endOf("month")
				// 	.format("YYYY-MM-DD"),
			],
			locale,
			dateFormat: "YYYY-MM-DD",
			monthFormat: "YYYY-MM-DD",
			show: true,
			dataSourceblNumber: [],
			dataSourceblOrderNumber: [],
			dataSourceblContainerNumber: [],
			dataSourceblPortDistrict: [],
			dataSourceblCustomerName: [],
		};
	},
	watch: {
		dateRange: {
			handler() {
				let params = this.req.params.condition;
				if (this.dateRange && this.dateRange.length == 2) {
					params.planArrivalTimeStart = this.dateRange[0]
						? this.dateRange[0] + " 00:00:00"
						: "";
					params.planArrivalTimeEnd = this.dateRange[1]
						? this.dateRange[1] + " 23:59:59"
						: "";
				} else {
					params.planArrivalTimeStart = "";
					params.planArrivalTimeEnd = "";
				}
			},
			deep: true,
		},
	},
	created() {},
	mounted() {},
	methods: {
		moment,
		search() {
			console.log(this.req);
			this.$emit("search", this.req);
		},
		// 重置
		reset() {
			this.req.params.condition = {};
			this.dateRange = [
				// dayjs()
				// 	.startOf("month")
				// 	.format("YYYY-MM-DD"),
				// dayjs()
				// 	.endOf("month")
				// 	.format("YYYY-MM-DD"),
			];
			// this.activeItem = "";
			this.show = true;
		},

		// 监听日期筛选器的变动
		onChange() {
			console.log("== date change ==");
			this.activeItem = "";
		},
		handleChange(value) {
			console.log(`selected ${value}`);
		},
		onSelect(value) {
			console.log("onSelect", value);
		},
		// 输入框模糊查询
		onChangeinput(searchText) {
			this.searchFormList.params = this.req.params;
			console.log("onChangeinput", searchText, this.searchFormList);

			queryReceivableList(this.searchFormList)
				.then((res) => {
					console.log(JSON.parse(res.data).data.list);
					let temp = JSON.parse(res.data).data.list;
					console.log(temp);
					// 提单
					this.dataSourceblNumber = [];
					temp.forEach((item) => {
						if (this.dataSourceblNumber.indexOf(item.blNo) == -1) {
							this.dataSourceblNumber.push(item.blNo);
						}
						console.log(this.dataSourceblNumber);
					});
					this.dataSourceblNumber = !searchText ? [] : this.dataSourceblNumber;

					// // 业务编号
					// this.dataSourceblOrderNumber = [];
					// temp.map((item) => {
					// 	if (this.dataSourceblOrderNumber.indexOf(item.orderNumber) == -1) {
					// 		this.dataSourceblOrderNumber.push(item.orderNumber);
					// 	}
					// 	return this.dataSourceblOrderNumber;
					// });
					// this.dataSourceblOrderNumber = !searchText
					// 	? []
					// 	: this.dataSourceblOrderNumber;

					// 箱号
					this.dataSourceblContainerNumber = [];
					temp.forEach((item) => {
						console.log(item.containerNumber);
						if (
							item.containerNumber &&
							item.containerNumber != null &&
							this.dataSourceblContainerNumber.indexOf(item.containerNumber) ==
								-1
						) {
							console.log(item.containerNumber);
							this.dataSourceblContainerNumber.push(item.containerNumber);
						}
					});
					this.dataSourceblContainerNumber = !searchText
						? []
						: this.dataSourceblContainerNumber;

					// // 港区
					this.dataSourceblPortDistrict = [];
					temp.forEach((item) => {
						if (
							this.dataSourceblPortDistrict.indexOf(item.portDistrict) == -1
						) {
							this.dataSourceblPortDistrict.push(item.portDistrict);
						}
					});
					this.dataSourceblPortDistrict = !searchText
						? []
						: this.dataSourceblPortDistrict;

					// 客户名称
					this.dataSourceblCustomerName = [];
					temp.forEach((item) => {
						if (
							this.dataSourceblCustomerName.indexOf(item.customerName) == -1
						) {
							this.dataSourceblCustomerName.push(item.customerName);
						}
					});
					this.dataSourceblCustomerName = !searchText
						? []
						: this.dataSourceblCustomerName;
				})
				.catch((err) => {
					this.$message.error(err);
				});
		},
	},
};
</script>
<style lang="less" scoped>
.bs-example {
	width: 100%;
	height: 120px;
}
.lineone {
	width: 100%;
	height: 33.3%;
	display: flex;
	align-items: center;
	justify-content: left;
}
.linetwo {
	display: flex;
	height: 33.3%;
	align-items: center;
	justify-content: left;
}
.linethree {
	display: flex;
	height: 33.3%;
	align-items: center;
	justify-content: flex-end;
}
.select-option {
	width: 20%;
	display: flex;
	align-items: center;
	justify-content: left;
}
.label-name {
	width: 70px;
}
.input-style {
	width: 60%;
}
.select-date {
	width: 32%;
	display: flex;
	align-items: center;
	justify-content: left;
	/deep/.ant-form-item {
		margin-bottom: 0;
	}
}
</style>
